import { Button, Modal } from 'react-bootstrap';
import useT from '../../i18n/useT';

const CreateTicket = ({ formData, setFormData, show, setShow, submit, loading, onFiles }) => {
    const t = useT();
    return (
        <Modal show={show} onHide={() => setShow(false)} centered size='lg'>
            <Modal.Header closeButton><h3>{t("tickets.newTicket")}</h3></Modal.Header>
            <Modal.Body>
                <form onSubmit={submit} className='row'>
                    <div className='col-md-8 mt-3'>
                        <div className='form-group'>
                            <label>{t("tickets.subject")}</label>
                            <input type='text' placeholder={t("tickets.shortSummary")} className='form-control' value={formData.subject || ""} onChange={(e) => setFormData((prev) => ({ ...prev, subject: e.target.value }))} />
                        </div>
                    </div>
                    <div className='col-md-4 mt-3'>
                        <div className='form-group'>
                            <label>{t("tickets.priority")}</label>
                            <select className='form-control' value={formData.priority || ""} onChange={(e) => setFormData((prev) => ({ ...prev, priority: e.target.value }))}>
                                <option value="">{t("tickets.selectPriority")}</option>
                                <option value="low">{t("tickets.prLow")}</option>
                                <option value="medium">{t("tickets.prMedium")}</option>
                                <option value="high">{t("tickets.prHigh")}</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-md-6 mt-3'>
                        <div className='form-group'>
                            <label>{t("tickets.problemType")}</label>
                            <select className='form-control' value={formData.problem_type || ""} onChange={(e) => setFormData((prev) => ({ ...prev, problem_type: e.target.value }))}>
                                <option value="">{t("tickets.selectType")}</option>
                                <option value="payment">{t("tickets.ptPayment")}</option>
                                <option value="transportation">{t("tickets.ptTransportation")}</option>
                                <option value="documents">{t("tickets.ptDocuments")}</option>
                                <option value="vehicle">{t("tickets.ptVehicle")}</option>
                                <option value="other">{t("tickets.ptOther")}</option>
                            </select>
                        </div>
                    </div>
                    <div className='col-md-6 mt-3'>
                        <div className='form-group'>
                            <label>{t("tickets.attachments")}</label>
                            <input type='file' multiple className='form-control' onChange={(e) => onFiles(Array.from(e.target.files))} />
                        </div>
                    </div>
                    <div className='col-md-12 mt-3'>
                        <div className='form-group'>
                            <label>{t("tickets.message")}</label>
                            <textarea rows={5} placeholder={t("tickets.describeIssue")} className='form-control' value={formData.message || ""} onChange={(e) => setFormData((prev) => ({ ...prev, message: e.target.value }))} />
                        </div>
                    </div>
                    <div className='col-md-12 mt-4'>
                        <Button type='submit' disabled={loading} style={{ width: "100%" }}>
                            {loading ? <div className="spinner-border spinner-border-sm text-light" role="status"></div> : t("tickets.createTicket")}
                        </Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
};

export default CreateTicket;
